<template>
	<section v-if="isSectionContentFilled" class="location-text-section">
		<div class="location-text-section__content">
			<div v-if="bottom && pageTextSection2.files && pageTextSection2.files[0]" class="location-text-section__image">
				<GlobalImage
					:src="`${storageUrl}${pageTextSection2.files[0].path}`"
					:alt="$t('modules.location_module.location.text_section.car_rental', { city: cmsLocation[`name${locale.toUpperCase()}`] })"
					:height="1160" />
			</div>
			<div v-if="sectionContent && sectionContent.content" class="location-text-section__text">
				<template v-for="(node, index) in parsedContent" :key="index">
					<GlobalImage v-if="node.type === 'image'" :src="node.src || ''" :alt="node.alt || ''" quality="95" />
					<div v-else class="location-text-section__text-content" v-html="node.content"></div>
				</template>
			</div>
		</div>
	</section>
</template>

<script setup lang="ts">
const props = defineProps<{
	bottom?: boolean // if bottom, there'll be image header
}>()

const { storageUrl } = useStorageService()
const { locale } = useI18n()
const cmsLocation = inject<Ref<ICMSLocationModel>>('cmsLocation')!
const pageTextSection = inject<Ref<ICMSLocationContent>>('pageTextSection')!
const pageTextSection2 = inject<Ref<ICMSLocationContent>>('pageTextSection2')!
const sectionContent = ref<ICMSLocationContentTranslations>(
	props.bottom
		? pageTextSection2.value?.translations.find((translation) => translation.language === locale.value)?.content[0]
		: pageTextSection.value?.translations.find((translation) => translation.language === locale.value)?.content[0],
)

const parsedContent = computed(() => {
	if (!sectionContent.value?.content || typeof sectionContent.value.content !== 'string') return []

	const content = sectionContent.value.content as string
	const nodes: Array<{ type: string; content?: string; src?: string; alt?: string }> = []

	const imgRegex = /<img[^>]+src="([^"]+)"[^>]*alt="([^"]*)"[^>]*>/g

	let match

	let lastIndex = 0

	while ((match = imgRegex.exec(content)) !== null) {
		if (match.index > lastIndex) {
			nodes.push({
				type: 'text',
				content: content.slice(lastIndex, match.index),
			})
		}

		nodes.push({
			type: 'image',
			src: match[1],
			alt: match[2],
		})

		lastIndex = match.index + match[0].length
	}

	if (lastIndex < content.length) {
		nodes.push({
			type: 'text',
			content: content.slice(lastIndex),
		})
	}

	return nodes
})

watch(
	() => parsedContent.value,
	(newVal) => {
		console.log('parsedContent', newVal)
	},
	{ deep: true, immediate: true },
)

const isSectionContentFilled = computed(() => {
	if (sectionContent.value) {
		return sectionContent.value.content !== ''
	}
	return false
})
</script>

<style lang="scss">
@import './TextSection.scss';
</style>
